import React from "react";
import ReactDOM from "react-dom/client";
import App from "@/App";

// NOTE: We intentionally do NOT import index.css / App.css here.
// The landing page in public/index.html owns its own styling and any
// global resets / Tailwind base layer would override its dark theme.
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}
